//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import differenceWith from 'lodash/differenceWith'
import isEmpty from 'lodash/isEmpty'

import RbPromoToggle from '@/elements/plp/header/promo-toggles/rb-promo-toggle.vue'

import {
  ALL_PROMOS,
  GREEN_LABEL,
  PST_PROMOS,
  RED_LABEL,
  SCARCITY_PROMO,
  YELLOW_LABEL,
} from '@/scripts/constants/promos'

import { PROMO_TIMER_TICK } from '@/scripts/constants/promos'
import { mapGetters } from 'vuex'
import wcs from '@/scripts/libs/wcs'
import PromoToggles from '@/scripts/libs/promo-toggles'
import { WcsPromotions } from '@/scripts/libs/wcs/promotions'
import RbDate from '@/utils/rb-date'

const { flashSale } = wcs.getStoreConfig()

export default {
  name: 'rb-promo-toggles',
  components: {
    RbPromoToggle,
  },
  props: {
    facetUrl: String,
    firstToggle: String,
    appliedFacets: {
      type: Array,
      default: () => [],
    },
  },
  inject: ['toggleFacets'],
  data() {
    return {
      name: 'rb-promo-toggles',
      filled: 0,
      remains: 90,
      allPromoTime: 90,
      isIconRed: false,
      isCountdownRed: false,
      isFlashVisible: true,
      originalPromotions: [],
      filteredPromotions: [],
      toggles: [],
      promotionsTimeToLiveInterval: null,
      countDownStatus: '',
      togglesAreLoading: true,
      activeToggle: null,
    }
  },
  computed: {
    ...mapGetters(['translation', 'newsletterSubmitCounter']),
    canShowPromoPanel() {
      return (
        this.toggles?.filter((promo) => !isEmpty(promo))?.length > this.minimumNumberOfPromoToggles
      )
    },
    minimumNumberOfPromoToggles() {
      return this.allPromosToggleIsPresent ? 1 : 0
    },
    allPromosToggleIsPresent() {
      return this.toggles.find((toggle) => toggle.id === ALL_PROMOS)
    },
  },
  watch: {
    newsletterSubmitCounter() {
      this.filteredPromotions = PromoToggles.getTogglesWithUserCluster(this.originalPromotions)
      this.resetPromotionsTimeToLiveTimer()
    },
    appliedFacets(newVal, prevVal) {
      if (newVal === prevVal) {
        return
      }
      this.setActive(newVal)
    },
  },
  async mounted() {
    await this.getPromotions()
    this.setActive(this.appliedFacets)
  },
  beforeDestroy() {
    this.promotionsTimeToLiveInterval && clearInterval(this.promotionsTimeToLiveInterval)
  },
  methods: {
    labelToShow(label) {
      const rg = new RegExp(/([a-zA-Z])\.([a-zA-Z])/)
      return rg.test(label) ? this.$t(label) : label
    },
    resetPromotionsTimeToLiveTimer() {
      this.promotionsTimeToLiveInterval && clearInterval(this.promotionsTimeToLiveInterval)

      this.handlePromotionsTimeToLive(this.filteredPromotions)
    },
    comparePromotions(a, b) {
      return a.entryValue === b.entryValue
    },
    isPromoActive(id) {
      if (Array.isArray(this.activeToggle)) {
        return !!this.activeToggle.find((el) => el.id === id)
      }
      return this.activeToggle === id
    },
    async getPromotions() {
      this.togglesAreLoading = true
      const promoToggles = await PromoToggles.getPromoToggles()
      this.originalPromotions = promoToggles
      this.filteredPromotions = PromoToggles.getTogglesWithUserCluster(promoToggles)
      PromoToggles.setHasPromotion(!!promoToggles)
      this.handlePromotionsTimeToLive(this.filteredPromotions)
    },
    toggleExpiredPromotion(originalPromotions, promotionsInProgress) {
      const promotionFacetsNotInProgress = differenceWith(
        originalPromotions,
        promotionsInProgress,
        this.comparePromotions
      ).flatMap((promo) => promo.entryValue)

      if (promotionFacetsNotInProgress.length > 0) {
        promotionFacetsNotInProgress.forEach((promo) => {
          if (this.appliedFacets.includes(promo)) {
            this.togglePromo([promo])

            const isActiveTogglePst = this.activeToggle === PST_PROMOS
            const isActiveToggleScarcity = this.activeToggle === SCARCITY_PROMO
            const areScarcityPromosEnded = !promotionsInProgress.some((promo) =>
              promo.id.includes(SCARCITY_PROMO)
            )

            if (isActiveTogglePst || (isActiveToggleScarcity && areScarcityPromosEnded)) {
              this.activeToggle = null
            }
          }
        })
      }
    },
    handlePromotionsTimeToLive(promotions) {
      if (!promotions || promotions.filter((promo) => isEmpty(promo)).length > 1) {
        return
      }

      this.promotionsTimeToLiveInterval = setInterval(() => {
        const promotionsInProgress = promotions.filter((promo) => {
          if (promo.id === ALL_PROMOS) {
            return true
          }

          return WcsPromotions.isPromotionInProgress(
            promo.startDateTimestamp,
            promo.endDateTimestamp
          )
        })

        const allPromos = promotionsInProgress.find((promo) => promo.id === ALL_PROMOS)
        if (allPromos) {
          allPromos.entryValue = this.mapAllPromoEntryValues(promotionsInProgress)
          allPromos.badge = this.firstToggle
        }

        const mergedPromoToggles = PromoToggles.mergePromoToggles(promotionsInProgress)

        const singleScarcity = mergedPromoToggles.find((promo) => promo.isFlash)

        if (singleScarcity) {
          this.formatAndShowScarcityInformation(singleScarcity)
        }

        if (this.activeToggle) {
          this.toggleExpiredPromotion(promotions, promotionsInProgress)
        }
        const originalOrder = this.originalPromotions.map((promo) => `${promo.entryValue[0]}`)
        this.toggles = PromoToggles.sortPromotions(originalOrder, mergedPromoToggles)
        if (this.togglesAreLoading) {
          this.togglesAreLoading = false
        }
      }, PROMO_TIMER_TICK)
    },
    mapAllPromoEntryValues(promotionsInProgress) {
      return promotionsInProgress
        .filter((promo) => promo.id !== ALL_PROMOS)
        .flatMap((promo) => promo.entryValue)
    },
    formatAndShowScarcityInformation(scarcityPromo) {
      const promoDurationRange = scarcityPromo.endDate - scarcityPromo.startDate
      const promoDuration = RbDate.calcInterval(RbDate.getTimeDate(), promoDurationRange)
      this.allPromoTime = promoDuration.seconds

      const currentDuration = RbDate.calcInterval(
        RbDate.getTimeDate(),
        scarcityPromo.endDateTimestamp
      )
      this.remains = currentDuration.seconds

      if (this.remains >= 0) {
        this.filled = ((this.allPromoTime - this.remains) * 100) / this.allPromoTime
        this.countDownStatus = GREEN_LABEL
      } else {
        this.isFlashVisible = false
      }
      if (this.remains <= flashSale.redCountdownStart) {
        this.isCountdownRed = true
        this.countDownStatus = YELLOW_LABEL
      }
      if (this.remains <= flashSale.redIconStart) {
        this.isIconRed = true
        this.countDownStatus = RED_LABEL
      }
    },
    cleanAllActivePromos() {
      this.toggles.forEach((promo) => {
        promo?.entryValue?.forEach((entry) => this.$emit('removeFaces', entry))
      })
    },
    handlePromoPanel(id) {
      this.cleanAllActivePromos()
      if (this.isPromoActive(id)) {
        this.removeSelectedFacet(id)
      } else {
        this.removeSelectedFacet(this.activeToggle)
        this.findAndTogglePromos(id)
      }
    },
    findAndTogglePromos(id) {
      const promo = this.toggles.find((promo) => promo.id === id)
      if (promo) {
        this.toggleFacets(promo?.entryValue)
      }
    },
    removeSelectedFacet(id) {
      const selected = this.toggles.find((t) => t.id === id) || {}
      this.toggleFacets(selected?.entryValue, undefined, true)
    },
    togglePromo(values) {
      this.toggleFacets(values)
    },
    getPromoIcon(promo) {
      const promoIcon = promo?.icon?.toLowerCase()
      return `common__icon--${promoIcon}`
    },
    getPromoIconActive(promo) {
      const promoIcon = promo?.icon?.toLowerCase()
      return `common__icon--${promoIcon}-active`
    },
    setActive(appliedFacet) {
      const allPromotions = this.filteredPromotions
        .filter((promo) =>
          WcsPromotions.isPromotionInProgress(promo.startDateTimestamp, promo.endDateTimestamp)
        )
        .flatMap((promo) => promo.entryValue)
      const mappedToggles = this.filteredPromotions.map((promo) => {
        const isCurrentPromoScarcity = promo.isFlash
        const promoId = isCurrentPromoScarcity ? SCARCITY_PROMO : promo.id
        return {
          id: promoId,
          entryValue: promo.entryValue,
        }
      })
      const appliedPromos = appliedFacet.filter((facet) => allPromotions.includes(facet))
      const isAllPromosSelected =
        allPromotions.length > 1 && allPromotions.every((promo) => appliedPromos.includes(promo))
      if (isAllPromosSelected) {
        this.activeToggle = ALL_PROMOS
      } else {
        const currentPromo = mappedToggles.find(
          (promo) =>
            promo.entryValue?.length &&
            promo.entryValue.every((promo) => appliedPromos.includes(promo))
        )
        if (currentPromo) {
          this.activeToggle = currentPromo.id
        } else {
          this.activeToggle = null
        }
      }
    },
  },
}
